import * as R from "ramda";
import { validateObject, validateField } from "util/validation";

const editMediaContraints = {
  title: {
    presence: {
      message: "^Title must not be blank",
    },
  },
};

const contributorConstraints = {
  "role.id": {
    presence: {
      allowEmpty: false,
      message: "^You must select a role",
    },
  },
  website: {
    presence: false,
    format: {
      pattern: /^[^ "]+$/,
      message: "^Invalid website",
    },
  },
  twitterHandle: {
    presence: false,
    format: {
      pattern: /^@[A-Za-z0-9_]+$/,
      message: "^Invalid X handle",
    },
  },
};

export const validateContributorField = (field, value, errors = {}) =>
  validateField(contributorConstraints, ...field, value, errors);

export const validateContributor = R.partial(validateObject, [
  contributorConstraints,
]);

export const validateEditMediaField = (field, value, errors = {}) =>
  validateField(editMediaContraints, ...field, value, errors);

export const validateEditMedia = R.partial(validateObject, [
  editMediaContraints,
]);
